import { ApplicationApi } from 'api';

export const repairKeys = {
	all: ['repair'] as const,
	getRepair: (repairId: number) =>
		[...repairKeys.all, 'repair', repairId] as const,
	getRepairsBySerialNumbers: (serialNumbers: string[]) =>
		[...repairKeys.all, 'bySerialNumbers', serialNumbers] as const,
};

export const useRepairQuery = (api: ApplicationApi, repairId: number) => ({
	queryKey: repairKeys.getRepair(repairId),
	queryFn: async () => (await api.getRepair(repairId)).data,
});

export const repairsBySerialNumbersQuery = (
	api: ApplicationApi,
	serialNumbers: string[]
) => ({
	queryKey: repairKeys.getRepairsBySerialNumbers(serialNumbers),
	queryFn: async () =>
		(await api.getRepairsBySerialNumbers(serialNumbers)).data,
});
